module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-04.1a8bf35b.jpg";